export function getTeamModelAlbumUrl({
  teamId,
  modelRepositoryId,
  albumId,
}: {
  teamId: string;
  modelRepositoryId: string;
  albumId: string;
}) {
  return `/t/${teamId}/model/${modelRepositoryId}/album/${albumId}`;
}
